import React from "react";
import "./Projects.css";

const Projects = () => {
  const projects = [
    {
      title: "Real Estate Website",
      description: "Property listing and search platform with geolocation",
      tech: ["React", "Node.js", "PostgreSQL", "AWS"],
      image: require("../images/pj-2.PNG"),
      liveLink: "https://estateswebsite.netlify.app/",
      githubLink: "https://github.com/JudithOyugi/",
      featured: true,
    },
    {
      title: "Restaurant Cuisine Platform",
      description: "Restaurant menu and reservation platform with geolocation",
      tech: ["React", "Node.js", "MySQL", "AWS"],
      image: require("../images/pj-4.PNG"),
      liveLink: "https://fanakarestaurant.netlify.app/",
      githubLink: "https://github.com/JudithOyugi/",
      featured: false,
    },
    {
      title: "Ecommerce Electronics Platform",
      description: "Online marketplace for electronics products",
      tech: ["React", "Node.js", "Express.js", "MySQL"],
      image: require("../images/electronics.PNG"),
      liveLink: "https://electronikshop.netlify.app/",
      githubLink: "https://github.com/JudithOyugi/",
      featured: false,
    },
    {
      title: "Cybersecurity Learning Platform",
      description: "Online learning platform for cybersecurity courses",
      tech: ["React", "Node.js", "Express.js", "MySQL"],
      image: require("../images/linda.PNG"),
      liveLink: "https://lindaio.netlify.app/",
      githubLink: "https://github.com/JudithOyugi/",
      featured: false,
    },

    {
      title: "Financial Dashboard",
      description:
        "Real-time analytics dashboard for financial data visualization",
      tech: ["HTML", "CSS", "JavaScript", "Node.js", "Express.js", "MySQL"],
      image: require("../images/pj-3.PNG"),
      liveLink: "https://restaurant-inventory-system.netlify.app/reports",
      githubLink: "https://github.com/JudithOyugi/",
      featured: false,
    },
    {
      title: "TC3 Africa",
      description: "Wellness and mental health platform ",
      tech: ["WordPress", "PHP", "MySQL"],
      image: require("../images/tc.PNG"),
      liveLink: "https://tc3africa.org/",
      githubLink: "https://github.com/JudithOyugi/",
      featured: false,
    },

    {
      title: "Bus Booking App",
      description: "Bus ticket booking platform with geolocation",
      tech: ["Flutter", "Dart", "Firebase", "Google Maps"],
      image: require("../images/pj-66g.PNG"),
      liveLink:
        "https://drive.google.com/file/d/1N9JQIslwnWU-r-53yipsTyFi3aP-s7bn/view?usp=drivesdk",
      githubLink: "https://github.com/JudithOyugi/",
      featured: false,
    },
    {
      title: "Quiz App",
      description: "Quiz application with real-time leaderboard",
      tech: ["Flutter", "Dart", "Firebase"],
      image: require("../images/pj-55.PNG"),
      liveLink:
        "https://drive.google.com/file/d/1N6gqzcl60Zq85_SL8biekRTjghv7Nur2/view?usp=drivesdk",
      githubLink: "https://github.com/JudithOyugi/",
      featured: false,
    },
  ];
  return (
    <section className="projects-section">
      <div className="projects-container">
        <h2 className="section-title">Featured Projects</h2>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div className="project-card" key={index}>
              <div className="project-image">
                <img src={project.image} alt={project.title} />
                <div className="project-overlay">
                  <div className="project-links">
                    <a
                      href={project.liveLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-link"
                    >
                      Live Demo
                    </a>
                    <a
                      href={project.githubLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-link"
                    >
                      GitHub
                    </a>
                  </div>
                </div>
              </div>
              <div className="project-info">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-tech">
                  {project.tech.map((tech, index) => (
                    <span key={index} className="tech-tag">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
